module.exports = __webpack_public_path__ + "img/stock3.88410427.png";